const React = require('react')
const { useHistory } = require('react-router-dom')
const { Table, UncontrolledTooltip } = require('reactstrap')
const { useFormatBytes, useResponsive, BREAKPOINTS } = require('@hooks')
const { useNetworkConfig } = require('@contexts')

require('@styles/components/transactions.css')

const NFTOpinionCollectionLogs = props => {
    const { data } = props
    const history = useHistory()
    const { network } = useNetworkConfig()
    const formatBytes = useFormatBytes()
    const isMobile = useResponsive(BREAKPOINTS.large)

    return (
        <Table responsive style={isMobile ? { display: 'block', overflowX: 'auto', whiteSpace: 'nowrap' } : {}}>
            <thead>
                <tr>
                    <th>Tx Hash</th>
                    <th>Location</th>
                    <th>Timestamp</th>
                    <th>Writer</th>
                    <th>Action</th>
                    <th>Description</th>
                </tr>
            </thead>
            <tbody>
                {data?.length === 0 ? (
                    <tr>
                        <td colSpan='6' style={{ textAlign: 'center', padding: '40px 0', height: '400px' }}>
                            <div
                                style={{
                                    width: '72px',
                                    height: '72px',
                                    backgroundColor: 'rgba(255, 193, 7, 0.15)',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    margin: '0 auto 12px'
                                }}
                            >
                                <i
                                    className='fas fa-inbox'
                                    style={{
                                        fontSize: '24px',
                                        color: 'var(--grey-color)'
                                    }}
                                />
                            </div>
                            <div style={{ fontWeight: 'bold', fontSize: '16px' }}>There are no matching entries</div>
                            <div style={{ color: 'var(--grey-color)', marginTop: '4px' }}>Please try again later</div>
                        </td>
                    </tr>
                ) : (
                    <>
                        {data?.map((log, index) => {
                            return (
                                <tr key={index}>
                                    <td>
                                        <span
                                            id={`tx-hash-${log.txHash}`}
                                            className={`${network.name}-text-color cursor-pointer`}
                                            onClick={() => history.push(`/${network.name}/tx/${log.txHash}`)}
                                        >
                                            {formatBytes(log.txHash, 12, 9, 0)}
                                        </span>
                                        <UncontrolledTooltip placement='top' target={`tx-hash-${log.txHash}`}>
                                            {log.txHash}
                                        </UncontrolledTooltip>
                                    </td>
                                    <td>{log.location}</td>
                                    <td>{log.timestamp}</td>
                                    <td>{log.writer}</td>
                                    <td>{log.action}</td>
                                    <td>{log.description}</td>
                                </tr>
                            )
                        })}
                    </>
                )}
            </tbody>
        </Table>
    )
}

module.exports = { NFTOpinionCollectionLogs }
